import React, { Component } from 'react';
import { makeStyles } from "@material-ui/core/styles";
import { ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles';
import Header from '../Nav/Header';
import { Route } from 'react-router-dom';
import LoginPage from './LoginPage';
import { theme } from '../../Config/theme';
import PrivateRoute from '../Nav/PrivateRoute';
import AddPage from './AddPage';
import OverviewPage from './OverviewPage';

export default function IndexPage(props) {


    const classes = useStyles();
    let headerBar = <React.Fragment></React.Fragment>;
    if (props.authentication.loggedIn) {
        headerBar = <div className={classes.header}>
            <Header {...props}></Header>
        </div>;
    }
    return (
        <MuiThemeProvider theme={theme}>
            <div className={classes.dashboard}>
                {headerBar}
                <div>
                    <Route path="/login" component={() => <LoginPage {...props} />} />
                    <PrivateRoute loggedIn={props.authentication.loggedIn} exact path="/" children={<AddPage {...props}></AddPage>} />
                    <PrivateRoute loggedIn={props.authentication.loggedIn} exact path="/overview" children={<OverviewPage {...props} actions = {props.actions}></OverviewPage>} />
                </div>
            </div>
        </MuiThemeProvider>
    )
}


const useStyles = makeStyles({
    dashboard: {
        display: "inline-block",
        width: "100%",
    }
});

